export const VALID_OUTCOME_USAGES = {
  IS_APPLICATION_OUTCOME: 'is_application_outcome',
  IS_ALERT_OUTCOME: 'is_alert_outcome',
  IS_INVESTIGATION_OUTCOME: 'is_investigation_outcome',
  IS_WORKFLOW_OUTCOME: 'is_workflow_outcome',
};

/**
 * A similar hardcoding of System Outcome defaults is used for validation
 * on the back end (`SYSTEM_OUTCOME_DETAILS` in
 * Typhon/src/modules/outcomes/constant.ts).
 * Any updates here should be reflected in that map as well.
 */
export const SYSTEM_OUTCOMES_DEFAULT_USAGES_MAP = {
  approved: [VALID_OUTCOME_USAGES.IS_APPLICATION_OUTCOME, VALID_OUTCOME_USAGES.IS_WORKFLOW_OUTCOME],
  'confirmed risk': [VALID_OUTCOME_USAGES.IS_INVESTIGATION_OUTCOME, VALID_OUTCOME_USAGES.IS_WORKFLOW_OUTCOME],
  denied: [VALID_OUTCOME_USAGES.IS_APPLICATION_OUTCOME, VALID_OUTCOME_USAGES.IS_WORKFLOW_OUTCOME],
  dismissed: [
    VALID_OUTCOME_USAGES.IS_ALERT_OUTCOME,
    VALID_OUTCOME_USAGES.IS_INVESTIGATION_OUTCOME,
    VALID_OUTCOME_USAGES.IS_WORKFLOW_OUTCOME,
  ],
  'manual review': [VALID_OUTCOME_USAGES.IS_WORKFLOW_OUTCOME],
  suspicious: [VALID_OUTCOME_USAGES.IS_ALERT_OUTCOME, VALID_OUTCOME_USAGES.IS_WORKFLOW_OUTCOME],
};
